import React from 'react';
import { FormattedMessage } from 'react-intl';
import { truncate } from '../../lib/functions';
import Title from '../title';

export default (props) => {
  const title = truncate(props.title, 45);

  return (
    <div className="col-9">
      <Title
        text={
          <FormattedMessage
            id="purchaseTitle.title"
            defaultMessage="Your group is ready to purchase:"
          />
        }
        bigger
      />
      <h2>{title}</h2>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/desktop/components/make-purchase/purchase-title.js